/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { List } from 'antd'
import { Modal } from 'antd-mobile'
import { AdvEmpty } from '@components/AdvEmpty'
import { EMPTY_ICON } from '@constants/index'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { ClubInfoItem } from '@store/clubStore'
import { getBetTypeName } from '@utils/utils'

// img
import BunnyCharacter from '@assets/images/popup/bunny-character.png'
// css
import { ModalBg, CharacterImgWrap, ListBtnStyle } from '@styles/base.style'
import { Button, PopupBtnStyle, ButtonWrap } from '@styles/button.style'
import { OneFoldClubList } from './index.style'


const OneFoldPopup: React.FC = props => {
  const { globalStore, clubStore, matchupStore } = useRootStore()
  const { visibleOneFoldPopup } = globalStore
  const { singleBetPossibleClubs, singleBetType } = clubStore
  const tracks = singleBetPossibleClubs || []
  const betTypeName = getBetTypeName(singleBetType)

  const onCloseModal = () => {
    globalStore.setVisibleOneFoldPopup(false)
  }

  const onClickClubItemButton = (item: ClubInfoItem) => {
    matchupStore.changeClubId(item.id)
    onCloseModal()
  }

  const renderOneFoldClubListItem = (item: ClubInfoItem) => {
    return (
      <Button css={ListBtnStyle} className="one-fold-club" onClick={() => onClickClubItemButton(item)}>
        <List.Item>
          <span className="club-name">
            {item.name}
          </span>
          <span className="club-visit">클럽방문</span>
        </List.Item>
      </Button>
    )
  }

  const localeAdvEmpty = { emptyText: <AdvEmpty ico={EMPTY_ICON.ONE_FOLD_CLUB} /> }

  return (
    <Fragment>
      <Modal
        transparent
        visible={visibleOneFoldPopup}
        maskClosable={false}
        onClose={onCloseModal}
        className="custom-dialog middle-size character-popup"
        title={
          <Fragment>
            <h1 className="title">1폴드 가능 클럽</h1>
            <p className="notice">&#8251;1폴드 가능 클럽은 배당이 낮을 수 있습니다.</p>
          </Fragment>
        }
      >
        <List
          className="one-fold-club-list"
          css={OneFoldClubList}
          bordered
          dataSource={tracks}
          renderItem={renderOneFoldClubListItem}
          locale={localeAdvEmpty}
        />
        <ButtonWrap className="custom-dialog-btn-wrap">
          <Button secondary onClick={onCloseModal} css={PopupBtnStyle} className="one-button">
            확인
          </Button>
        </ButtonWrap>

        <ModalBg onClick={onCloseModal} />

        <CharacterImgWrap className="character-img-wrap">
          <img src={BunnyCharacter} alt="캐릭터" className="character-img" />
          <span className="speech-bubble">
            <div className="speech-bubble--tit">{betTypeName}</div>
            <p className="speech-bubble--txt">
              <span>1폴드 베팅이 불가능한</span>
              <br />
              클럽입니다.
            </p>
            <p className="speech-bubble--txt">
              <span className="point-color yellow">2폴드 이상</span> 베팅을
              <br />
              시도해 주세요.
            </p>
          </span>
        </CharacterImgWrap>
      </Modal>
    </Fragment>
  )
}

export default observer(OneFoldPopup)
